<template>
    <div class="search-bar">
        <div class="d-flex align-items-center">
            <label class="mr-sm-2 mb-0">Pencarian</label>
            <form class="form-inline d-flex flex-wrap">
                <div class="form-group mb-0">
                    <input type="text" style="min-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                        placeholder="kode..." data-lpignore="true">
                </div>
                <div class="form-group mb-0">
                    <date-picker v-model="searchDate" range type="date" placeholder="Tanggal Action" :editable="false" format="DD-MM-YYYY"></date-picker>
                </div>
                <div class="input-group">
                    <multiselect class="w-auto flex-grow-1" v-model="searchGudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="input-group mr-1">
                    <multiselect class="w-auto flex-grow-1" v-model="searchGrade" :options="gradeOptions" :placeholder="'Pilih grade'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGrade = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="form-group mb-0">
                    <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                    <button class="btn btn-light" @click.prevent="resetSearch">Reset</button>
                </div>
            </form>
        </div>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>

        <b-modal v-model="selectGrade" size="lg" :hide-header="true" :hide-footer="true">
            <grade-selector :selected="gradeOptions" @selected="gradeSelected" @cancel="selectGrade = false"></grade-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import GudangSelector from '../gudangs/Selector';
import GradeSelector from '../grades/Selector';

export default {
    components: {
        Multiselect,
        DatePicker,
        GudangSelector,
        GradeSelector,
    },

    data() {
        return {
            userOptions: [],
            selectGudang: false,
            gudangOptions: [],
            selectGrade: false,
            gradeOptions: [],
            searchGudang: null,
            searchGrade: null,
            searchText: '',
            searchDate: '',
        }
    },

    methods: {
        doSearch() {
            let self = this,
                data = {
                    searchText: self.searchText,
                    searchDate: self.searchDate[0] && self.searchDate[1] ? self.searchDate : null,
                    searchGudangId: self.searchGudang ? self.searchGudang.id : '',
                    searchGradeId: self.searchGrade ? self.searchGrade.id : '',
                };
            self.$emit('search-set', data);
        },

        resetSearch() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudang = null;
            this.searchGrade = null;
            this.$emit('search-reset');
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.searchGudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },

        gradeSelected(grade) {
            let self = this;

            self.gradeOptions.push(grade);
            self.searchGrade = Object.assign({}, grade);
            self.selectGrade = false;
        },
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
